module.exports = __webpack_public_path__ + "prize-2.c7c2019b.png";